import { PrimaryButton } from '@client/new/components/button';
import { navigate, PATHS } from '@client/routes';
import { AuthLayout } from '../auth.layout';
import { Progress } from './progress';
import { F1, Option } from '../../../helpers/types';
import * as React from 'react';

const options = [
  { value: 'social-media', label: 'Social media (Instagram, Facebook, etc.)' },
  { value: 'creator-referral', label: 'Referral from another creator' },
  { value: 'friend-referral', label: 'Referral from a friend' },
  { value: 'search', label: 'Search engine (Google, etc.)' },
  { value: 'ads', label: 'Playbook advertising or marketing' },
  { value: 'other', label: 'Other (please specify)' },
];

const Options = ({
  options,
  selected,
  select,
}: {
  options: Array<Option>;
  selected: string;
  select: F1<string>;
}) => {
  return (
    <div className="flex flex-col gap-3">
      {options.map((option) => (
        <div
          key={option.value + option.label}
          className={`${
            selected === option.value
              ? 'bg-primary-dark text-white'
              : 'border  bg-white'
          } w-full px-5 py-4 font-bold border-gray-200 rounded-xl cursor-pointer text-center`}
          onClick={() => select(option.value)}
        >
          {option.label}
        </div>
      ))}
    </div>
  );
};

export const ReferralSourceStepPage = () => {
  const [referrer, setReferrer] = React.useState('');
  const [referralSource, setReferralSource] = React.useState('');
  const [other, setOther] = React.useState('');
  const url = new URL(window.location.href);
  const email = url.searchParams.get('email');

  if (!email) {
    navigate(PATHS.SIGN_UP);
    return null;
  }

  const complete =
    (referralSource === 'other' && other?.length) ||
    (referralSource === 'creator-referral' && referrer?.length) ||
    (referralSource?.length &&
      referralSource !== 'other' &&
      referralSource !== 'creator-referral');

  return (
    <AuthLayout showGoBack title={'How did you hear about Playbook?'}>
      <div className="flex flex-col  w-full items-center">
        <div className="mt-8 w-full flex flex-col gap-3">
          <Options
            selected={referralSource}
            options={options}
            select={setReferralSource}
          />

          {referralSource === 'other' && (
            <div className="w-full flex flex-col gap-3 border-t border-gray-200 pt-10 mt-5">
              <label className="font-bold text-center">
                Please specify <span className="text-red-500">*</span>
              </label>
              <input
                aria-label="Please specify"
                name="other"
                type="text"
                required
                className="input w-full text-center"
                placeholder="Type here"
                value={other}
                onChange={(e) => setOther(e.target.value)}
              />
            </div>
          )}

          {referralSource === 'creator-referral' && (
            <div className="w-full flex flex-col gap-3 border-t border-gray-200 pt-10 mt-5">
              <label className="font-bold text-center">
                Which creator referred you?{' '}
                <span className="text-red-500">*</span>
              </label>
              <input
                aria-label="Creator referral"
                name="referrer"
                type="text"
                required
                className="input w-full text-center"
                placeholder="Type here"
                value={referrer}
                onChange={(e) => setReferrer(e.target.value)}
              />
            </div>
          )}

          <PrimaryButton
            large
            className={`${complete ? 'btn' : 'btn-disabled'} w-full mt-5`}
            onClick={() => complete && navigate(PATHS.HOME)}
          >
            Continue
          </PrimaryButton>
        </div>
      </div>
    </AuthLayout>
  );
};
